<template>
    <div class="row panel-body">
        <form method="post" :action="saveRoute" enctype='multipart/form-data'>
            <input type="hidden" name="_token" :value="csrfToken"/>


            <div
                    v-if="footageAudioFixNeeded && videoChange === 'english'"
                    class="alert alert-danger"
                    style="max-width: 30%;"
            >
                <b>Attention!</b><br/>
                There has been correction for the Audio files. You will have to fetch the
                corrected voices from the Audio-Team (or Google Drive), put them into
                the footage folder and fix the project for the new audio files.
            </div>

            <table style="border-spacing: 10px;">
                <thead>
                <th>Video Changes</th>
<!--                <th>Voice Changes (Script/Sync)</th>-->
                <th>SFX Changes</th>
                <th></th>
                </thead>
                <tbody>
                <tr>
                    <td valign="top">
                        <select id="videoChange" name="videoChange" v-model="videoChange" class="form-control">
                            <option value="">- Choose</option>
                            <option value="0">No</option>
                            <option value="english">English Video</option>
                        </select>

                        <videoproject-file
                                v-if="videoChange === 'english'"
                                id="rendered_video_master_meta"
                                :file_names="lessonCode+'_XX.mp4'"
                                enforce_filename="1"
                                field_name="rendered_video_master"
                                icon="fa fa-film"
                                isrequired="true"
                                :lesson_code="lessonCode"
                        ></videoproject-file>

                        <videoproject-file
                                v-if="videoChange === 'english'"
                                id="after_effects_project_master_meta"
                                :file_names="lessonCode+'_XX.aep'"
                                enforce_filename="1"
                                field_name="after_effects_project_master"
                                icon="fa fa-file-video-o"
                                isrequired="true"
                                :lesson_code="lessonCode"
                        ></videoproject-file>

                        <videoproject-file
                                v-if="videoChange === 'english'"
                                id="footage_meta"
                                file_names="(Footage).zip"
                                enforce_filename="0"
                                field_name="footage"
                                icon="fa fa-file-archive-o"
                                isrequired="true"
                                :lesson_code="lessonCode"
                        ></videoproject-file>

                        <div v-if="videoChange === 'english'" class="form-group col-sm-12 text-left">
                            <strong style="color:darkred" id="localizationAffectedLabel">What type of changes have been
                                made to the video?*</strong><br/>

                            <div class="radio">
                                <label for="localizationAffectedYes1" class="control-label">
                                    <input type="radio"
                                           required
                                           id="localizationAffectedYes1"
                                           name="videoChangesAffectLocalization"
                                           value="1"
                                           onchange="document.getElementById('localizationAffectedLabel').style.color = '#676a6c'"
                                    />
                                    <strong>English wording</strong> changes that affect translations and/or <strong>animation
                                    has been added/removed</strong> that needs to be localized, e.g. characters or
                                    police car.<br/>
                                    (For <u>all countries</u>, we need to re-watch the video and <u>write new
                                    localization instructions</u>, and then <u>re-localize the video</u>)
                                </label>
                            </div>
                            <div class="radio">
                                <label for="localizationAffectedYes2" class="control-label">
                                    <input type="radio"
                                           required
                                           id="localizationAffectedYes2"
                                           name="videoChangesAffectLocalization"
                                           value="2"
                                           onchange="document.getElementById('localizationAffectedLabel').style.color = '#676a6c'"
                                    />
                                    No words, <strong>only animation</strong> has changed that doesn't need to be
                                    localized, e.g. background.<br/>
                                    (<u>All countries</u> need to have the video <u>re-localized using</u> the <u>existing
                                    instructions</u>)
                                </label>
                            </div>
                            <div class="radio">
                                <label for="localizationAffectedNo" class="control-label">
                                    <input type="radio"
                                           required
                                           id="localizationAffectedNo"
                                           name="videoChangesAffectLocalization"
                                           value="0"
                                           onchange="document.getElementById('localizationAffectedLabel').style.color = '#676a6c'"
                                    />
                                    Only small <strong>English typos</strong> have been fixed.<br/>
                                    (For <u>English-first
                                    countries</u>, e.g. CA & KE, the video needs to be <u>re-localized</u> with the <u>existing
                                    instructions</u>)
                                </label>
                            </div>
                        </div>
                    </td>

<!--                    <td valign="top">-->
<!--                        <select v-model="audioChange" id="audioChange" name="audioChange" class="form-control">-->
<!--                            <option value="">- Choose</option>-->
<!--                            <option value="0">No - Voice did not change</option>-->
<!--                            <option value="1">Yes - Voice did change</option>-->
<!--                        </select>-->

<!--                        <videoproject-file-->
<!--                                v-if="audioChange === '1'"-->
<!--                                id="voice_english_meta"-->
<!--                                :file_names="lessonCode+'_XX_en.aif'"-->
<!--                                enforce_filename="1"-->
<!--                                field_name="voice_english"-->
<!--                                icon="fa fa-music"-->
<!--                                isrequired="true"-->
<!--                                :lesson_code="lessonCode"-->
<!--                        ></videoproject-file>-->
<!--                        <div v-if="audioChange === '1'" class="form-group col-sm-12 text-left">-->
<!--                            <strong style="color:darkred" id="audioAffectedLabel">Do these audio changes affect-->
<!--                                synchronization or other languages?*</strong><br/>-->
<!--                            <div class="radio">-->
<!--                                <label for="audioAffectedYes" class="control-label">-->
<!--                                    <input type="radio"-->
<!--                                           required-->
<!--                                           id="audioAffectedYes"-->
<!--                                           name="audioChangesAffectLanguagesOrSync"-->
<!--                                           value="1"-->
<!--                                           onchange="document.getElementById('audioAffectedLabel').style.color = '#676a6c'"-->
<!--                                    />-->
<!--                                    Yes: timing or words changed.-->
<!--                                </label>-->
<!--                            </div>-->
<!--                            <div class="radio">-->
<!--                                <label for="audioAffectedNo" class="control-label">-->
<!--                                    <input type="radio"-->
<!--                                           required-->
<!--                                           id="audioAffectedNo"-->
<!--                                           name="audioChangesAffectLanguagesOrSync"-->
<!--                                           value="0"-->
<!--                                           onchange="document.getElementById('audioAffectedLabel').style.color = '#676a6c'"-->
<!--                                    />-->
<!--                                    No: intonation, accent or pronunciation changed.-->
<!--                                </label>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </td>-->

                    <td valign="top">
                        <select v-model="sfxChange" id="sfxChange" name="sfxChange" class="form-control">
                            <option value="">- Choose</option>
                            <option value="0">No - SFX did not change</option>
                            <option value="1">Yes - SFX did change</option>
                        </select>

                        <videoproject-file
                                v-if="sfxChange === '1'"
                                id="sound_effects_meta"
                                :file_names="lessonCode+'_SFX.aif'"
                                enforce_filename="1"
                                field_name="sound_effects"
                                icon="fa fa-music"
                                isrequired="true"
                                :lesson_code="lessonCode"
                        ></videoproject-file>

                    </td>

                    <td valign="top">
                        <submit-button
                                :disabled="videoChange === '' || sfxChange === ''"></submit-button>
                    </td>
                </tr>
                </tbody>
            </table>
        </form>
    </div>
</template>

<script>
    export default {
        props: [
            'saveRoute',
            'lessonCode',
            'footageAudioFixNeeded',
        ],

        data: function() {
            return {
                csrfToken: window.csrfToken,
                videoChange: '',
                sfxChange: '',
            };
        },
    };
</script>
